// @ts-nocheck
/* eslint-disable import/no-unresolved */
/* eslint-disable import/order */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { selectState, actionProps } from 'utils/reduxActions';
import { homeActions } from 'screens/Home/reducer';
import { ReactReduxContext } from 'config/configureStore';
import connectSaga from 'utils/saga';
import saga from './saga';

import { clone, truthty, falsy, onChangeFnc } from 'utils/functions';
import { Container, Divider, withStyles } from '@material-ui/core';
import { processTypesActions } from 'screens/ProcessTypes/reducer';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CardHeader from '@material-ui/core/CardHeader';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import styles from './styles';
import ProcessTypeForm from './components/ProcessTypeForm';
import DeleteModal from 'commons/components/DeleteModal';
import MaintainersPaginator from '../../commons/components/MaintainersPaginator';
import TableActionMenu from 'commons/components/TableActionMenu';
import ModalLoss from './components/ModalLoss';
import { GetApp } from '@material-ui/icons';
import useAutomationTools from './hooks/useAutomationTools';
import { useAutomation } from 'utils/hooks/useAutomationPermission';
import { getAccessPolicy, getCurrentSubdomain } from 'utils/accessPolicy';

const useStyles = makeStyles(styles);

function ProcessTypes(props) {
  const { t } = useTranslation();
  const {
    objects,
    formIsOpen,
    formControls,
    edit,
    invalidControls,
    deleteIsOpen,
    actions,
    permissions,
    products,
    warehouses,
    packagingTypes,
    suppliers,
  } = props;

  const [processTypeList, setProcessTypeList] = useState([]);
  const [filter, setFilter] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItems, setSelectedItems] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const [modalLossOpen, setModalLossOpen] = useState(false);

  const { hasAutomation } = useAutomation();
  const accessPolicy = getAccessPolicy({
    subdomain: getCurrentSubdomain(),
    roleName: props.role?.name,
  });
  const {
    canCreate,
    canEdit,
    canDelete,
    canBulkEditLoss,
    canExport,
    automationActions,
  } = accessPolicy.processTypes;

  const { automationMenuItems, AutomationModals } = useAutomationTools({
    hasAutomation,
    allowedAutomationActions: automationActions,
    products,
    processTypes: objects.processTypes,
    warehouses,
    packagingTypes,
    suppliers,
    accounts: objects.accounts,
    actions,
  });

  useEffect(() => {
    const filteredList = Object.values(objects.processTypes || {})
      .filter((item) => item.name.toLowerCase().includes(filter.toLowerCase()))
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

    setProcessTypeList(filteredList);

    if (filteredList.length > 0) {
      const allSelected = filteredList.every((item) => selectedItems.has(item.id));
      setSelectAll(allSelected);
    } else {
      setSelectAll(false);
    }
  }, [objects.processTypes, filter, selectedItems]);

  useEffect(() => {
    actions.getStateFromApi();
    actions.getOperationalMasters();
  }, [actions]);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function toggleForm() {
    actions.disableErrors();
    actions.toggleForm('formIsOpen');
  }

  function closeForm() {
    actions.toggleForm('deleteIsOpen');
  }

  function toggleDelete() {
    handleClose();
    actions.toggleDelete(anchorEl.dataset.id);
  }

  function toggleEdit() {
    handleClose();
    const item = Object.values(objects.processTypes).find(
      (i) => i.id === Number(anchorEl.dataset.id),
    );
    actions.toggleEdit(item);
  }

  function changeControls(event) {
    onChangeFnc(actions.changeControls, event);
  }

  function submit(payloadOverride) {
    const payload = payloadOverride || formControls;

    if (falsy(payload.name)) {
      actions.setInvalidControls({
        name: true,
      });
    } else if (edit) {
      actions.editProcessType(props.toEditId, payload);
    } else {
      actions.createProcessType(payload);
    }
  }

  function submitDelete() {
    actions.deleteProcessType(props.toDeleteId);
  }

  function onFilterChange(event) {
    setFilter(event.target.value);
  }

  function handleItemCheckbox(itemId) {
    setSelectedItems((prev) => {
      const newSelected = new Set(prev);
      if (newSelected.has(itemId)) {
        newSelected.delete(itemId);
      } else {
        newSelected.add(itemId);
      }
      return newSelected;
    });
  }

  function handleSelectAll() {
    if (selectAll) {
      setSelectedItems(new Set());
    } else {
      const allIds = processTypeList.map((item) => item.id);
      setSelectedItems(new Set(allIds));
    }
    setSelectAll(!selectAll);
  }

  const handleOpenModalLoss = () => setModalLossOpen(true);
  const handleCloseModalLoss = () => setModalLossOpen(false);

  const classes = useStyles();

  const getListItem = (
    processType,
    openMenuHandler,
    closeMenuHandler,
    toggleEditHandler,
    toggleDeleteHandler,
  ) => (
    <ListItem key={`processType-${processType.id}`}>
      {canBulkEditLoss && (
        <Checkbox
          checked={selectedItems.has(processType.id)}
          onChange={() => handleItemCheckbox(processType.id)}
          color="primary"
        />
      )}
      <ListItemAvatar>
        <Avatar className={classes.blue}>{(processType.name || 'P')[0].toUpperCase()}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={processType.name}
        secondary={processType.product?.name ? `${processType.product.name} (${processType.product.Variety?.Fruit?.name || ''})` : ''}
      />
      <ListItemSecondaryAction>
        {(canEdit || canDelete) && (
          <>
            <IconButton onClick={openMenuHandler} data-id={processType.id}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              keepMounted
              open={truthty(anchorEl) && Number(anchorEl?.dataset.id) === processType.id}
              onClose={closeMenuHandler}
              elevation={1}
            >
              {canEdit && (
                <MenuItem onClick={toggleEditHandler}>
                  <ListItemIcon><EditIcon /></ListItemIcon>
                  {t('Edit')}
                </MenuItem>
              )}
              {canDelete && (
                <MenuItem onClick={toggleDeleteHandler}>
                  <ListItemIcon><DeleteIcon /></ListItemIcon>
                  {t('Delete')}
                </MenuItem>
              )}
            </Menu>
          </>
        )}
      </ListItemSecondaryAction>
    </ListItem>
  );

  return (
    <Container maxWidth={false}>
      <Grid container spacing={3} className={classes.container}>
        <Grid item xs={12}>
          <Typography variant="h3" component="h2" className={classes.marginTop}>
            {t('Process types')}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Card className={classes.root}>
            <CardHeader title={t('Filter')} />
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label={t('Name')}
                    value={filter}
                    onChange={onFilterChange}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <div className={classes.space}>
            <div>
              {canBulkEditLoss && (
                <>
                  <FormControlLabel
                    style={{ border: '1px solid #b2aeae', padding: '0 10px', borderRadius: '4px' }}
                    control={
                      <Checkbox
                        checked={selectAll}
                        onChange={handleSelectAll}
                        color="primary"
                        indeterminate={selectedItems.size > 0 && selectedItems.size < processTypeList.length}
                      />
                    }
                    label={t('Select all')}
                  />
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={selectedItems.size === 0}
                    style={{ marginLeft: '10px' }}
                    onClick={handleOpenModalLoss}
                  >
                    {t('Change loss percentage')} ({selectedItems.size})
                  </Button>
                </>
              )}
            </div>
            <div className={classes.actionMenuContainer}>
              {(canExport || automationMenuItems.length > 0) && (
                <TableActionMenu
                  buttonFullWidth={false}
                  buttonSize="medium"
                  buttonClassName={classes.actionMenuButton}
                  menuItems={[
                    ...(canExport
                      ? [
                        {
                          label: t('Export'),
                          listItems: [
                            {
                              label: t('Excel File (All)'),
                              onClick: actions.exportProcessTypes,
                              icon: GetApp,
                            },
                            {
                              label: t('Excel File (Selected)'),
                              onClick: () => actions.exportProcessTypes(Array.from(selectedItems)),
                              icon: GetApp,
                              disabled: selectedItems.size === 0,
                            },
                          ],
                        },
                      ]
                      : []),
                    ...automationMenuItems,
                  ]}
                />
              )}
            </div>
          </div>
        </Grid>

        <Grid item xs={12}>
          <Card className={classes.root}>
            <CardContent>
              {truthty(objects.processTypes) ? (
                <MaintainersPaginator
                  classes={classes}
                  list={processTypeList}
                  getListItem={getListItem}
                  openMenuHandler={handleClick}
                  closeMenuHandler={handleClose}
                  toggleEdit={toggleEdit}
                  toggleDelete={toggleDelete}
                />
              ) : (
                <Grid container justify="center">
                  <Typography variant="h6">{t('No process types found')}</Typography>
                </Grid>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <ProcessTypeForm
        isOpen={formIsOpen}
        toggleForm={toggleForm}
        changeControls={changeControls}
        controls={formControls}
        edit={edit}
        editingId={props.toEditId}
        submit={submit}
        invalidControls={invalidControls}
        classes={classes}
        hasAutomationPermission={hasAutomation}
        products={products}
        processTypes={objects.processTypes}
      />

      <DeleteModal
        isOpen={deleteIsOpen}
        toggleForm={closeForm}
        submit={submitDelete}
      />

      {canCreate && (
        <Fab color="primary" className={classes.fab} onClick={toggleForm}>
          <AddIcon />
        </Fab>
      )}

      <ModalLoss
        open={modalLossOpen}
        onClose={handleCloseModalLoss}
        processTypeList={processTypeList.filter((item) => selectedItems.has(item.id))}
        setSelectedItems={setSelectedItems}
      />

      <AutomationModals
        suppliers={suppliers}
      />
    </Container>
  );
}

const withSaga = connectSaga({ key: 'sagaProcessTypes', saga });

const withConnect = connect(
  selectState(
    'processTypes.invalidControls',
    'processTypes.formControls',
    'processTypes.deleteIsOpen',
    'processTypes.toDeleteId',
    'processTypes.formIsOpen',
    'processTypes.toEditId',
    'processTypes.edit',
    'app.objects',
    'app.permissions',
    'processTypes.products',
    'processTypes.warehouses',
    'processTypes.packagingTypes',
    'processTypes.suppliers',
    'app.role',
  ),
  actionProps(clone(clone.OBJECT, homeActions, processTypesActions)),
  null,
  { context: ReactReduxContext },
);

export default compose(withStyles(styles), withRouter, withConnect)(withSaga(ProcessTypes));
